import React, { useEffect, useState } from "react";
import { AppTextField, AppAutocomplete } from "components/common/inputs";
import { AppDialog } from "components/common/dialogs";
import { Stack } from "@mui/material";
import { AppButton } from "components/common/buttons";

const initialForm = {
  Name: "",
  DocumentCategory: "",
  Note: "",
};

const DocumentTypeFormDialog = ({
  open,
  onClose,
  onSubmit,
  documentType = null,
  documentCategoryOptions = [],
  defaultDocumentCategory = "",
  submitting = false,
}) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setForm({
        Name: documentType?.Name ?? "",
        DocumentCategory: documentType?.DocumentCategory ?? defaultDocumentCategory ?? "",
        Note: documentType?.Note ?? "",
      });
      setErrors({});
    }
  }, [defaultDocumentCategory, documentType, open]);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = async () => {
    if (submitting) return;
    const nextErrors = {};

    if (!form.Name.trim()) {
      nextErrors.Name = "Vui lòng nhập tên loại tài liệu";
    }

    if (!form.DocumentCategory.trim()) {
      nextErrors.DocumentCategory = "Vui lòng chọn nhóm tài liệu";
    }

    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    await onSubmit({
      Name: form.Name.trim(),
      DocumentCategory: form.DocumentCategory.trim(),
      Note: form.Note.trim() || null,
    });
  };

  return (
    <AppDialog
      open={open}
      onClose={submitting ? undefined : onClose}
      title={documentType ? "Chỉnh sửa loại tài liệu" : "Thêm mới loại tài liệu"}
      size="sm"
      loading={submitting}
      actions={
        <>
          <AppButton variant="outlined" color="inherit" onClick={onClose} disabled={submitting}>
            Hủy
          </AppButton>
          <AppButton variant="contained" onClick={handleSubmit} disabled={submitting} disableElevation>
            Lưu
          </AppButton>
        </>
      }
    >
        <Stack spacing={2} sx={{ pt: 0.5 }}>
          <AppTextField
            disabled={submitting}
            label="Tên loại tài liệu"
            value={form.Name}
            onChange={(_, event) => handleChange("Name")(event)}
            error={Boolean(errors.Name)}
            helperText={errors.Name}
            fullWidth
            required
            size="small"
            autoFocus
          />

          <AppAutocomplete
            options={documentCategoryOptions}
            value={form.DocumentCategory}
            onChange={(value) => {
              setForm((prev) => ({
                ...prev,
                DocumentCategory: value || "",
              }));
              setErrors((prev) => ({ ...prev, DocumentCategory: "" }));
            }}
            disabled={submitting}
            label="Nhóm tài liệu"
            error={Boolean(errors.DocumentCategory)}
            helperText={errors.DocumentCategory}
            required
          />

          <AppTextField
            disabled={submitting}
            label="Ghi chú"
            value={form.Note}
            onChange={(_, event) => handleChange("Note")(event)}
            fullWidth
            multiline
            minRows={3}
            size="small"
          />
        </Stack>
    </AppDialog>
  );
};

export default DocumentTypeFormDialog;
